import React, { useState } from 'react';
import Snackbar from '../../Snackbar/Snackbar';
import { useHasAudioInputDevices, useHasVideoInputDevices } from '../../../hooks/deviceHooks/deviceHooks';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

export function getSnackbarContent(hasAudio: boolean, hasVideo: boolean, error?: Error) {
  let headline = '';
  let message = '';

  switch (true) {
    // This error is emitted when the user or the user's system has denied permission to use the media devices
    case error?.name === 'NotAllowedError':
      headline = 'No podemos accedor a tus dispositivos:';

      if (error!.message === 'Permission denied by system') {
        // Chrome only
        message =
          'Revisa tus permisos para compartir audio y video.';
      } else {
        message =
          'Revisa tus permisos para compartir audio y video.';
      }

      break;

    // This error is emitted when input devices are not connected or disabled in the OS settings
    case error?.name === 'NotFoundError':
      headline = 'No podemos accedor a tus dispositivos:';
      message =
        'Revisa tus permisos para compartir audio y video.';
      break;

    // Other getUserMedia errors are less likely to happen in this app. Here we will display
    // the system's error message directly to the user.
    case Boolean(error):
      headline = 'Error Acquiring Media:';
      message = `${error!.name} ${error!.message}`;
      break;

    case !hasAudio && !hasVideo:
      headline = 'No podemos accedor a tus dispositivos:';
      message = 'Revisa tus permisos para compartir audio y video.';
      break;

    case !hasVideo:
      headline = 'No podemos accedor a tus dispositivos:';
      message = 'Revisa tus permisos para compartir audio y video.';
      break;

    case !hasAudio:
      headline = 'No podemos accedor a tus dispositivos:';
      message = 'Revisa tus permisos para compartir audio y video.';
  }

  return {
    headline,
    message,
  };
}

export default function MediaErrorSnackbar({ error }: { error?: Error }) {
  const hasAudio = useHasAudioInputDevices();
  const hasVideo = useHasVideoInputDevices();

  const { isAcquiringLocalTracks } = useVideoContext();

  const [isSnackbarDismissed, setIsSnackbarDismissed] = useState(false);

  const isSnackbarOpen = !isSnackbarDismissed && !isAcquiringLocalTracks && (Boolean(error) || !hasAudio || !hasVideo);

  const { headline, message } = getSnackbarContent(hasAudio, hasVideo, error);

  return (
    <Snackbar
      open={isSnackbarOpen}
      handleClose={() => setIsSnackbarDismissed(true)}
      headline={headline}
      message={message}
      variant="warning"
    />
  );
}
